import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  HEADER: `${cleanedFilename(__filename)}-header`,
  NO_STATS: `${cleanedFilename(__filename)}-no-stats`,
  STAT_INDICATOR: `${cleanedFilename(__filename)}-stat-indicator`,
};
